export const navLinks = [
  {
    id: 1,
    name: 'Home',
    path: '/',
    icon: 'home',
    active: false,
  },
  {
    id: 2,
    name: 'All Products',
    path: '/products',
    icon: 'products',
    active: false,
  },
  {
    id: 3,
    name: 'Categories',
    path: '/list-page/categories',
    icon: 'category',
    active: false,
  },
  {
    id: 4,
    name: 'Brands',
    path: '/list-page/brands',
    icon: 'brand',
    active: false,
  },
  {
    id: 5,
    name: 'Search',
    path: '/search',
    icon: 'Search',
    active: false,
  },
  {
    id: 6,
    name: 'About',
    path: '/about',
    icon: 'about',
    active: false,
  },
];
